import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './stylus/main.styl'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VLazyImagePlugin } from "v-lazy-image";

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(require('vue-cookies'))
Vue.use(VLazyImagePlugin);

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
